export const DESIGN_REGISTRY_LIST_BOT_DESIGNS = 'DESIGN_REGISTRY_LIST_BOT_DESIGNS';
export const DESIGN_REGISTRY_LIST_BOT_DESIGNS_SUCCESS = 'DESIGN_REGISTRY_LIST_BOT_DESIGNS_SUCCESS';
export const DESIGN_REGISTRY_LIST_BOT_DESIGNS_FAIL = 'DESIGN_REGISTRY_LIST_BOT_DESIGNS_FAIL';

export const DESIGN_REGISTRY_IMPORT_BOT_DESIGNS = 'DESIGN_REGISTRY_IMPORT_BOT_DESIGNS';
export const DESIGN_REGISTRY_IMPORT_BOT_DESIGNS_SUCCESS = 'DESIGN_REGISTRY_IMPORT_BOT_DESIGNS_SUCCESS';
export const DESIGN_REGISTRY_IMPORT_BOT_DESIGNS_FAIL = 'DESIGN_REGISTRY_IMPORT_BOT_DESIGNS_FAIL';

export const DESIGN_REGISTRY_BOT_DESIGNS_CLEAR = 'DESIGN_REGISTRY_BOT_DESIGNS_CLEAR';
